// ===============================
// Sticky ATC behavior controller
// ===============================

/** @type {HTMLElement | null} */
const bottomATC = document.querySelector('.bottom-atc');
/** @type {HTMLElement | null} */
const mainATC = document.querySelector('.product-action .addToCartBtn, .product-form__buttons .addToCartBtn');

let passedMainATC = false;

// --- Function: Adjust Customer Hub Position ---
/** @param {boolean} shouldPush */
function adjustCustomerHub(shouldPush) {
  /** @type {HTMLElement | null} */
  const hubWidget = document.querySelector('[class^="HubLauncherWidget__FloatingWidget-sc"]');
  
  // Guard clause: ensure hubWidget and bottomATC exist before accessing .style or .offsetHeight
  if (!hubWidget || !bottomATC) return;

  if (shouldPush) {
    // Calculate current height plus a buffer
    const offset = bottomATC.offsetHeight;
    hubWidget.style.transform = `translateY(-${offset}px)`;
    hubWidget.style.transition = 'transform 0.3s ease-in-out';
  } else {
    hubWidget.style.transform = 'translateY(0px)';
  }
}

// --- Observe main ATC visibility ---
// Only run if both elements were found on the page
if (mainATC && bottomATC) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        bottomATC.classList.remove('show');
        bottomATC.classList.add('hide');
        adjustCustomerHub(false);
      }
    },
    { threshold: 0 }
  );

  observer.observe(mainATC);

  // --- Scroll position detection ---
  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    // Calculate position
    const mainATCBottom = mainATC.getBoundingClientRect().bottom + window.scrollY;

    passedMainATC = currentScrollY > mainATCBottom;

    if (passedMainATC) {
      bottomATC.classList.add('show');
      bottomATC.classList.remove('hide');
      adjustCustomerHub(true);
    } else {
      bottomATC.classList.remove('show');
      bottomATC.classList.add('hide');
      adjustCustomerHub(false);
    }
  });
}

// --- Smooth Scroll Intercept ---
const stickyBtn = document.querySelector('.batc_btn');

if (stickyBtn) {
  stickyBtn.addEventListener('click', (e) => {
    // Stop the native abrupt HTML jump
    e.preventDefault(); 
    
    // Target the first variant picker so they see their options
    const target = document.querySelector('.product-v2__variant-picker'); 
    
    if (target) {
      // Offset for sticky headers (adjust this number as needed)
      const headerOffset = 120; 
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  });
}

// --- Sync Bottom ATC State with Main V2 ATC ---
document.addEventListener('DOMContentLoaded', () => {
  const v2MainATC = document.querySelector('.product-v2-container .addToCartBtn');
  const stickyBtnEl = document.querySelector('.batc_btn');

  if (v2MainATC && stickyBtnEl) {
    const syncButtonState = () => {
      // Find the label inside the main ATC (handling your V2 spans)
      const mainLabel = v2MainATC.querySelector('.js-atc-label') || v2MainATC.querySelector('span');
      const textToMirror = mainLabel ? mainLabel.textContent.trim() : v2MainATC.textContent.trim();
      
      // Mirror the text
      stickyBtnEl.textContent = textToMirror;

      // Mirror visual classes for CSS styling
      const mirrorClasses = ['oos', 'preorder', 'disabled'];
      mirrorClasses.forEach(cls => {
        stickyBtnEl.classList.toggle(cls, v2MainATC.classList.contains(cls));
      });

      // Mirror the functional disabled state
      if (v2MainATC.hasAttribute('disabled') || v2MainATC.disabled) {
        stickyBtnEl.setAttribute('disabled', 'disabled');
        stickyBtnEl.style.pointerEvents = 'none';
      } else {
        stickyBtnEl.removeAttribute('disabled');
        stickyBtnEl.style.pointerEvents = 'auto';
      }

      // Handle specific visual states
      const isComingSoon = v2MainATC.classList.contains('disabled') && !v2MainATC.classList.contains('oos');
      
      if (isComingSoon) {
        // Force the pink colour for Coming Soon using the exact hex from your CSS
        stickyBtnEl.style.setProperty('background', '#fd3170', 'important');
        stickyBtnEl.style.opacity = '0.5'; 
      } else {
        // Clear the inline background override so your normal CSS takes over
        stickyBtnEl.style.removeProperty('background');
        
        // Apply opacity styling for OOS
        if (v2MainATC.classList.contains('oos')) {
          stickyBtnEl.style.opacity = '0.5';
        } else {
          stickyBtnEl.style.opacity = '1';
        }
      }
    };

    // Run an initial sync immediately on load
    syncButtonState();

    // Watch the main ATC for changes triggered by v2.js
    const stateObserver = new MutationObserver(() => {
      syncButtonState();
    });

    stateObserver.observe(v2MainATC, {
      attributes: true,
      attributeFilter: ['disabled', 'class'], 
      childList: true,
      subtree: true,
      characterData: true
    });
  }
});